type AccountName = { firstName: string | null; lastName: string | null };

export function accountSignatureName(account: AccountName | null | undefined) {
  return [account?.firstName, account?.lastName].filter(Boolean).join(" ").trim();
}

/** [contracts.signature-name](../../../docs/product/contracts.md#contracts-signature-name): give signing fields immediate account-name feedback.
 * The server independently checks its current account record before any write. */
export function signatureMatchesAccountName(signature: string, account: AccountName | null | undefined) {
  const normalize = (name: string) => name.normalize("NFKC").trim().replace(/\s+/g, " ").toLowerCase();
  const savedName = accountSignatureName(account);
  return !!savedName && normalize(signature) === normalize(savedName);
}
